import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { MaintenanceEvent } from '../maintenance-event';
import { MaintenanceEventService } from '../maintenance-event.service';
import { MaintenanceEventComponent } from '../maintenance-event/maintenance-event.component';

@Component({
    selector: 'app-maintenance-event-list',
    templateUrl: './maintenance-event-list.component.html',
    styleUrls: ['./maintenance-event-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class MaintenanceEventListComponent implements OnInit {
	maintenanceEventShortTermRentalAPIList: any[]=[];
	shortTermRental: { shortTermRentalId: any; };
	visibilities: any;
	constructor(
		private maintenanceEventService: MaintenanceEventService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = maintenanceEventService.statuses;
		this.visibilities = maintenanceEventService.visibilities;
	}


	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() shortTermRentalId: any;
	// @Input() reservation: any;
	maintenanceEvents: any;
	maintenanceEvent: MaintenanceEvent;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any = [
		{ value: '0', name: 'Planned' },
		{ value: '1', name: 'In-process' },
		{ value: '2', name: 'Complete' }
	];

	resolutions: any = [
		{ value: '0', name: 'Notify Only' },
		{ value: '1', name: 'Refund' },
		{ value: '2', name: 'Relocate' },
		{ value: '3', name: 'Other' },
	];

	columns: any[] = [
		{ field: 'maintenanceEventId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'impactDesc', header: 'Impact Description', width: 'auto' },
		{ field: 'resolutionDesc', header: 'Resolution Description', width: 'auto' },
		{ field: 'resolution', header: 'Resolution', width: 'auto' },
		// { field: 'guestPriorNotifDaysNum', header: 'Prior Days to Notify', width: 'auto' },
		{ field: 'opsNotes', header: 'Operational Notes', width: 'auto' },
		{ field: 'startDate', header: 'Start Date', width: 'auto' },
		{ field: 'endDate', header: 'End Date', width: 'auto' },
		// { field: 'startTime', header: 'Start Time', width: 'auto' },
		// { field: 'endTime', header: 'End Time', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'visibility', header: 'Visibility', width: 'auto' },
		{ field: 'shortTermRentalId', header: 'Property Code(s)', width: 'auto' },
		{ field: 'floorOfProperty', header: 'Floor(s) of Property', width: 'auto' },
		{ field: 'adrBuildingName', header: 'Building Name', width: 'auto' },
		{ field: 'developmentId', header: 'Development', width: 'auto' }
	];

	getStatusName(maintenanceEvent: any) {
		if (maintenanceEvent?.status) {
			const status = this.statuses.find((e: any) => e.value == maintenanceEvent.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getResolution(maintenanceEvent: any) {
		if (maintenanceEvent?.resolution) {
			const resolution = this.resolutions.find((e: any) => e.value == maintenanceEvent.resolution);
			return resolution.name;
		}
		else {
			return '';
		}
	}

	ngOnInit(): void {
		if(this.shortTermRentalId){
			this.shortTermRental = {
				shortTermRentalId: this.shortTermRentalId
			}
			// this.maintenanceEventShortTermRentalAPIList.push(data);
		}
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.maintenanceEventId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-maintenanceEvent-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.shortTermRentalId)
				{
					// show only shortTermRentals that are assigned to this propertyCodeFilter
					let propertyIdFilter = { 'maintenanceEventShortTermRentalVOList.shortTermRentalVO.shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'equals' } };
					Object.assign(event.filters, propertyIdFilter);
				}

			const pageNumber = Math.round(event.first / event.rows);
			this.maintenanceEventService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.maintenanceEvents = res.data.maintenanceEvents;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.maintenanceEvents = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(maintenanceEvent: MaintenanceEvent) {
		try {
			this.formLoading = true;
			this.maintenanceEventService.update(maintenanceEvent)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.maintenanceEvents.map((maintenanceEvent, i) => {
							if (maintenanceEvent.maintenanceEventId === res.data.maintenanceEvent.maintenanceEventId) {
								this.maintenanceEvents[i] = res.data.maintenanceEvent;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(maintenanceEvent: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(maintenanceEvent));

			this.formLoading = true;
			this.maintenanceEventService.delete(maintenanceEvent.maintenanceEventId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.maintenanceEvents.splice(this.maintenanceEvents.indexOf(maintenanceEvent), 1);
						this.recordTotal = this.maintenanceEvents.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'MaintenanceEvent ' + maintenanceEvent.maintenanceEventId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'MaintenanceEvent ' + maintenanceEvent.maintenanceEventId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "50vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add MaintenanceEvent'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MaintenanceEventComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addMaintenanceEventCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(maintenanceEvent: MaintenanceEvent) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "50vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			maintenanceEvent: maintenanceEvent,
			title: 'Edit MaintenanceEvent'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MaintenanceEventComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateMaintenanceEventCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteMaintenanceEventCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addMaintenanceEventCB(maintenanceEvent: MaintenanceEvent) {
		console.log('Adding MaintenanceEvent: ' + JSON.stringify(maintenanceEvent));
		// if we don't have a maintenanceEvents array yet...
		if (!this.maintenanceEvents) {
			this.maintenanceEvents = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.maintenanceEvents.unshift(maintenanceEvent);

		// no idea what this is but it is required to update the array
		this.maintenanceEvents = [...this.maintenanceEvents];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MaintenanceEvent ' + maintenanceEvent.maintenanceEventId + ' Added', life: 3000 });
	}

	updateMaintenanceEventCB(maintenanceEvent: MaintenanceEvent) {
		console.log('Updating MaintenanceEvent: ' + JSON.stringify(maintenanceEvent));
		let itemIndex = this.maintenanceEvents.findIndex((item: any) => item.maintenanceEventId === maintenanceEvent.maintenanceEventId);
		this.maintenanceEvents[itemIndex] = maintenanceEvent;

		// no idea what this is but it is required to update the array
		this.maintenanceEvents = [...this.maintenanceEvents];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MaintenanceEvent ' + maintenanceEvent.maintenanceEventId + ' Updated', life: 3000 });
	}

	deleteMaintenanceEventCB(maintenanceEvent: MaintenanceEvent) {
		console.log('Removing MaintenanceEvent: ' + maintenanceEvent);
		this.maintenanceEvents.splice(this.maintenanceEvents.indexOf(maintenanceEvent), 1);
		this.recordTotal = this.maintenanceEvents.length;

		// no idea what this is but it is required to update the array
		this.maintenanceEvents = [...this.maintenanceEvents];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MaintenanceEvent ' + maintenanceEvent.maintenanceEventId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.maintenanceEvents ? this.first === (this.maintenanceEvents.length - this.rows) : true; }
	isFirstPage(): boolean { return this.maintenanceEvents ? this.first === 0 : true; }
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}

	checkDate(startDate: string, endDate: string): string {
		const today = new Date();
		const start = new Date(startDate + 'T00:00:00'); // Ensure local time
		const end = new Date(endDate + 'T23:59:59');     // Include full day
	  
		if (today < start) {
		  return "Planned";
		} else if (today > end) {
		  return "Complete";
		} else {
		  return "In-process";
		}
	  }

	  getVisibility(visibility: any) {
		if (visibility) {
			const status = this.visibilities.find((e: any) => e.value == visibility);
			return status.name;
		}
		else {
			return '';
		}
	}

	getPropertyCodes(maintenanceEvent: any) {
		var propertyCode = null;
		var count = 0;
		if (maintenanceEvent?.maintenanceEventShortTermRentalAPIList.length > 0){
			maintenanceEvent?.maintenanceEventShortTermRentalAPIList.forEach(maintenanceEventShortTermRental => {
				if(count == 0){
					propertyCode = maintenanceEventShortTermRental.propertyCode;
				}else{
					propertyCode = propertyCode +", "+ maintenanceEventShortTermRental.propertyCode+", ";
				}
				count = count + 1;
			});
		}
		return propertyCode;
	}
	  
}
